/**
 * This will iterate over the array and remove the stoarge items by key
 * @param storageType - storage type can be localStorage or sessionStorage
 * @param prefixName - prefixName can be anything starts with a given character or word
 */
export function removeStorageItemsByKey(storageType: Storage, prefixName: string): void {
  if (storageType && prefixName.length > 0) {
    Object.keys(storageType).forEach(function (key) {
      if (key.substring(0, prefixName.length) === prefixName) {
        storageType.removeItem(key);
      }
    });
  }
}

/**
 * Remove the stoarge items by key
 * @param storageType - storage type can be localStorage or sessionStorage
 * @param key - key can be localStorage or sessionStorage name
 */
export function removeData(storageType: Storage, key: string) {
  storageType.removeItem(key);
}
